import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);

window.UIkit = UIkit;

import modular from "modujs";
import * as modules from "./_modules";
import "./_lazyload";
import { setupAOS, setupIframes } from "./_animations";

setupIframes();

const app = new modular({
    modules: modules,
});

window.addEventListener('load', event => {
    const $style = document.getElementById("main-css");

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener("load", (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
});

function init() {
    app.init(app);
    document.documentElement.classList.add("is-loaded", "is-ready");
    document.documentElement.classList.remove("is-loading");
    
    setupAOS();
}

jQuery(function($) {
    let animationDone = false;

    function isInViewport($el) {
        // Vérifie que $el existe et que c'est bien un objet jQuery avec au moins un élément
        if (!$el || !$el.length || typeof $el.offset !== "function" || typeof $el.outerHeight !== "function") {
            return false;
        }

        let elementTop = $el.offset()?.top ?? 0; // fallback à 0 si offset() undefined
        let elementBottom = elementTop + ($el.outerHeight() ?? 0);

        let viewportTop = $(window).scrollTop() ?? 0;
        let viewportBottom = viewportTop + ($(window).height() ?? 0);

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }


    function animateNumbers() {
        $('.chiffres-defilants-container.reset-container .chiffre').each(function() {
            let $this = $(this);
            let target = parseInt($this.text(), 10);
            $this.text('0'); // on part de zéro
            $({ countNum: 0 }).animate(
                { countNum: target },
                {
                    duration: 3500,
                    easing: 'swing',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text(this.countNum); // valeur finale exacte
                    }
                }
            );
        });
    }

    $(window).on('scroll resize', function() {
        if (!animationDone && isInViewport($('.chiffres-defilants-container.reset-container'))) {
            animateNumbers();
            animationDone = true;
        }
    });

    // Vérifie aussi au chargement initial
    if (isInViewport($('.chiffres-defilants-container.reset-container'))) {
        animateNumbers();
        animationDone = true;
    }
});

jQuery(function($){
    var hasHomeBanner = $('.banner-home').length > 0;
    var $accessibilityActions = $('[data-accessibility-actions]');

    function getViewportHeight() {
        if (window.visualViewport && window.visualViewport.height) {
            return window.visualViewport.height;
        }

        return window.innerHeight || $(window).height() || 0;
    }

    function updateAccessibilityActionsVisibility() {
        if (!$accessibilityActions.length) {
            return;
        }

        if (!hasHomeBanner) {
            $accessibilityActions.addClass('is-visible');
            return;
        }

        var scrollTop = $(window).scrollTop() || 0;
        var threshold = getViewportHeight() * 0.6;

        if (scrollTop >= threshold) {
            $accessibilityActions.addClass('is-visible');
        } else {
            $accessibilityActions.removeClass('is-visible');
        }
    }

    function mountAccessibilityActions() {
        var $onetap = $('.onetap-container-toggle').first();

        if ($accessibilityActions.length && $onetap.length && !$onetap.parent().is($accessibilityActions)) {
            $accessibilityActions.append($onetap);
        }

        updateAccessibilityActionsVisibility();
    }

    mountAccessibilityActions();
    setTimeout(mountAccessibilityActions, 500);
    setTimeout(mountAccessibilityActions, 1500);

    $(window).on('scroll resize orientationchange', function() {
        updateAccessibilityActionsVisibility();
    });

    var $btn = $('#search-toggle-btn');
    var $popup = $('#search-popup');
    var $input = $('#site-search-input');

    function openPopup() {
        $popup.addClass('open');
        $btn.attr('aria-expanded', 'true');
        // focus après animation (petit timeout pour fluidité)
        setTimeout(function(){ $input.focus(); }, 160);
    }
    function closePopup() {
        $popup.removeClass('open');
        $btn.attr('aria-expanded', 'false');
        $btn.focus();
    }
    // toggle au clic sur la loupe
    $btn.on('click', function(e){
        e.preventDefault();
        if ($popup.hasClass('open')) closePopup();
        else openPopup();
    });

    // clic sur le bouton de validation => le form standard sera soumis, pas besoin d'intercepter
    // fermer au Esc
    $(document).on('keydown', function(e){
        if (e.key === 'Escape' || e.keyCode === 27) {
            if ($popup.hasClass('open')) {
                closePopup();
            }
        }
    });

    // clic en dehors ferme la popup
    $(document).on('click touchstart', function(e){
        if ($popup.hasClass('open')) {
            var $target = $(e.target);
            if ( !$target.closest('#site-search-toggle').length ) {
                closePopup();
            }
        }
    });

    // empêcher propagation des clics dans la popup (pour le listener qui ferme)
    $popup.on('click', function(e){
        e.stopPropagation();
    });

    // soumettre avec Enter dans le champ (form natif gère déjà Enter) : on peut fermer après soumission
    $('.search-form').on('submit', function(){
        // optional: close popup immediately so navigation feels snappy before page reload
        closePopup();
        return true; // laisser WordPress gérer la requête
    });

    function closeNavSubmenus() {
        $('.menu-item-has-children').removeClass('open -focus');
    }

    $('.menu-item-has-children > a').on('click touchstart', function (e) {
        const $parent = $(this).parent('.menu-item-has-children');

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if ($parent.hasClass('open')) {
            $parent.removeClass('open -focus');
        } else {
            closeNavSubmenus();
            $parent.addClass('open -focus');
        }
    });

    $(document).on('click touchstart', function(e) {
        if (!$(e.target).closest('.menu-item-has-children').length) {
            closeNavSubmenus();
        }
    });

    $(window).on('scroll', function() {
        closeNavSubmenus();
    });
    function isMobile() {
        return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    }
    if (!isMobile() && document.querySelector('#filtre-localisation')) {
        const filtrelocalisation = new Choices('#filtre-localisation', {
            searchEnabled: false,
            itemSelectText: '',
        });
    }

    if (!isMobile() && document.querySelector('#filtre-type')) {
        const filtretype = new Choices('#filtre-type', {
            searchEnabled: false,
            itemSelectText: '',
        });
    }

    $(document).on('click', '#return-to-map', function(e) {
        e.preventDefault();
        var targetSelector = $(this).attr('href');
        if (!targetSelector) return;

        var $target = $(targetSelector);
        if (!$target.length) return;

        var offset = 250;
        var targetTop = $target.offset().top - offset;
        $('html, body').animate({ scrollTop: targetTop }, 600);
    });
});
